<template>
  <div class="c-personal">
    <h1 class="c-users-information__title">{{ $t('usersInformation.personal.title') }}</h1>
    <p class="c-users-information__text">{{ $t('usersInformation.personal.text') }}</p>
    <!-- row-1 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.personal.firstName') }}</label>
      <p4a-input
        :value="firstName"
        @input="$emit('update:firstName', $event)"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
        :autofocus="true"
      />
    </div>
    <!-- row-2 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.personal.lastName') }}</label>
      <p4a-input
        :value="lastname"
        @input="$emit('update:lastname', $event)"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
      />
    </div>
    <!-- row-3 -->
    <!-- <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.personal.prefixes') }}</label>
      <p4a-input
        :type="'text'"
        :inputSize="'small'"
        :leftIcon="''"
        :autofocus="true"
      />
    </div> -->
    <!-- row-4 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.personal.email') }}</label>
      <p4a-input
        :value="personalEmail"
        @input="$emit('update:personalEmail', $event)"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
      />
    </div>
    <!-- row-5 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.personal.workphone') }}</label>
      <p4a-input
        :value="workPhone"
        @input="$emit('update:workPhone', $event)"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
      />
    </div>
    <!-- row-6 -->
    <!-- <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.personal.mobile') }}</label>
      <p4a-input
        :type="'text'"
        :inputSize="'small'"
        :leftIcon="''"
        :autofocus="true"
      />
    </div> -->
    <!-- row-7 -->
    <div class="form-row">
      <p4a-checkbox
        :checked="receiveNewsletter"
        @change="updateReceiveNewsletter"
        :value="$t('usersInformation.personal.checkbox')"
        :text="$t('usersInformation.personal.checkbox')"
        :disabled="false">
      </p4a-checkbox>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    firstName: {
      type: String
    },
    lastname: {
      type: String
    },
    personalEmail: {
      type: String
    },
    workPhone: {
      type: String
    },
    receiveNewsletter: {
      type: Boolean
    }
  },
  methods: {
    updateReceiveNewsletter (checkbox) {
      this.$emit('update:receiveNewsletter', !this.receiveNewsletter)
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/personal.vue